import { DemoAlarmIngestPayload } from '@hakimo-ui/hakimo/types';

/**
 * Flatten the per-situation alarm selections into the wire format the
 * ingest API expects. The `situations` grouping on the payload is
 * client-side only (used by `notifyIngestResult` for per-situation
 * toasts) — the API receives a single deduped `alarm_ids` array.
 */
export function buildIngestBody(payload: DemoAlarmIngestPayload): string {
  const alarmIds = new Set<string>();
  payload.situations.forEach((s) =>
    s.alarmIds.forEach((id) => alarmIds.add(id))
  );

  return JSON.stringify({
    alarm_ids: Array.from(alarmIds),
    custom_alarm_ids: payload.manualAlarmIds ?? [],
  });
}
